import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import Sizes from 'builder/styles/sizes'
import Media from 'builder/styles/media'
import backgroundImage from './bg.png'

export const Card = styled.div`
  display: flex;
  border-radius: ${Sizes['2XS']};
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-color: ${Colors.Blue10};

  ${Media.AbovePhone` 
    padding: 20px 24px 24px;
    gap: 20px;
  `}
`
